import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { AdminBarChart, AdminDonutChart, AdminLineChart, DistributionList } from '../../components/admin/AdminChart';
import { AdminMetricCard, AdminPageTitle, DateRange, Panel } from '../../components/admin/AdminPrimitives';
import { habitCompletion, moodDistribution, participationSeries } from '../../data/admin';
export function AdminDailyCheck() {
  const [range, setRange] = useState('30d');
  return <div className="space-y-4" data-id="element-1628" data-mp="vdjhaw81k5xz">
      <AdminPageTitle title="Daily Check" subtitle="Análise agregada de participação e conclusão. Nenhum registro individual de saúde é exibido nesta área." action={<DateRange value={range} onChange={setRange} data-id="element-1630" data-mp="15b7avitwv7ek" />} data-id="element-1629" data-mp="vem68ylszyb9" />

      <section className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-1631" data-mp="159mk84apw8lz">
        <AdminMetricCard label="Participação diária" value="81,4%" delta={2.6} hint="Do DAU que abriu o Daily Check" accent data-id="element-1632" data-mp="hkbpb3g1t8fr" />
        <AdminMetricCard label="Taxa de conclusão" value="62,3%" delta={1.8} hint="Dias fechados nos 100 Bee de base" data-id="element-1633" data-mp="3f0nl3jr7n9em" />
        <AdminMetricCard label="Bee médio" value="74,2" delta={0.9} hint="Base de 100 Bee" data-id="element-1634" data-mp="3nt8ptvy0bfkg" />
        <AdminMetricCard label="Consistência semanal" value="4,8 dias" delta={3.4} hint="Média de dias registrados por semana" data-id="element-1635" data-mp="3ssk8jahxov4o" />
      </section>

      <AdminLineChart title="Participação e conclusão" question="A participação cresce sem derrubar a taxa de conclusão?" data={participationSeries} xKey="day" series={[{
      id: 'participation',
      name: 'Participação (%)'
    }, {
      id: 'completion',
      name: 'Conclusão (%)'
    }]} height={280} data-id="element-1636" data-mp="30467smzgnkpf" />

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-2" data-id="element-1637" data-mp="kcs9f3jk57nx">
        <AdminBarChart title="Conclusão por hábito" question="Quais dos seis hábitos são concluídos com mais frequência?" data={habitCompletion} xKey="habit" series={[{
        id: 'completion',
        name: 'Concluído (%)'
      }]} data-id="element-1638" data-mp="pb2319pmw07f" />
        <Panel title="Abandono por hábito" hint="Onde o usuário abre o Check e não conclui o hábito." data-id="element-1639" data-mp="9lvkuymt8t1c">
          <DistributionList items={habitCompletion.slice().sort((a, b) => b.dropoff - a.dropoff).map(habit => ({
          label: `${habit.habit} · ${habit.xp} Bee`,
          value: habit.dropoff
        }))} data-id="element-1640" data-mp="4o3sk3i974wm" />
        </Panel>
      </div>

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-[1fr_1.2fr]" data-id="element-1641" data-mp="3mu03mmzcu2e4">
        <AdminDonutChart title="Distribuição de humor" question="Como a base se distribui entre os cinco humores?" data={moodDistribution} nameKey="mood" valueKey="value" data-id="element-1642" data-mp="3i16y3ww2aq0z" />
        <Panel title="Privacidade desta análise" data-id="element-1643" data-mp="2pb73cqv9ytbu">
          <p className="flex items-start gap-2 text-[12.5px] leading-relaxed text-muted" data-id="element-1644" data-mp="14uz6b77tac9l">
            <ShieldCheckIcon size={15} className="mt-[1px] shrink-0 text-gold" aria-hidden="true" data-id="element-1645" data-mp="19mhbk7gvaz0d" />
            Humor, sono e demais hábitos aparecem apenas como proporções da base. A
            plataforma não expõe, nesta tela, qual usuário registrou qual humor, e nenhuma
            leitura aqui constitui interpretação clínica.
          </p>
          <ul className="mt-3 space-y-2" data-id="element-1646" data-mp="1nmjmf9qrcs64">
            {[['Base do Daily Check', '100 Bee'], ['Hábitos na base', '6'], ['Bônus da Foto do Dia', '+10 Bee, fora da base'], ['Liberação do Post completo', '50 Bee no dia']].map(([label, value]) => <li key={label} className="flex items-baseline justify-between gap-3 border-b border-sand-line pb-2 last:border-b-0 last:pb-0" data-id="element-1647" data-mp="1ioi4is52iyw8">
                <span className="text-[12px] text-muted" data-id="element-1648" data-mp="75dzcp2ugaps">{label}</span>
                <span className="bee-num text-[12.5px] font-bold text-deep" data-id="element-1649" data-mp="nfesci2o886z">{value}</span>
              </li>)}
          </ul>
        </Panel>
      </div>
    </div>;
}